/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  /* ------------------------------------------------------------------
   * Variant photo filter (Sarah & Stone)
   * On the products listed below, the gallery only shows the photos for
   * the selected colour.
   * How to tag photos: set each photo's alt text to the exact colour
   * name, e.g. "Khaki & Brown Handle". For a photo that belongs to
   * several colours, separate them with a pipe: "Black | Green".
   * Photos with any other alt text (or none) show for every colour.
   * To turn it on for another product, add its handle to the list.
   * ------------------------------------------------------------------ */
  var VMF_HANDLES = ['the-sienna', 'the-milano', 'the-winona', 'the-amalfi', 'the-delilah', 'the-verona-1', 'the-maribel', 'the-ariel-bohemian-straw-wallet', 'the-valeria', 'the-marina', 'the-daisy-1', 'the-emila', 'the-kiara', 'the-jean', 'the-camille-1', 'rosie', 'the-wendy'];

  function vmfOptionValues(info) {
    var values = [];
    info.querySelectorAll('variant-selects input[type="radio"], variant-selects option, variant-selects [data-popout-option]').forEach(function(el) {
      var v = (el.getAttribute('data-value') || el.value || '').trim();
      if (v && values.indexOf(v) === -1) values.push(v);
    });
    return values;
  }

  function vmfMarkLoaded(img) {
    img.classList.remove('is-loading');
    var p = img.parentNode;
    if (p && p.classList) p.classList.remove('is-loading');
    var gp = p && p.parentNode;
    if (gp && gp.classList) gp.classList.remove('is-loading');
  }

  function vmfWatchImages(el) {
    if (!el) return;
    el.querySelectorAll('img').forEach(function(img) {
      if (img.__vmfWatched) return;
      img.__vmfWatched = true;
      img.addEventListener('load', function() { vmfMarkLoaded(img); });
    });
  }

  function vmfRefreshImages(el) {
    if (!el) return;
    el.querySelectorAll('img.is-loading').forEach(function(img) {
      if (img.complete && img.naturalWidth > 0) vmfMarkLoaded(img);
    });
  }

  function vmfSetup(info) {
    if (info.__vmf) return info.__vmf;
    var gallery = info.querySelector('product-images');
    if (!gallery) return null;
    var scope = gallery.closest('[data-section-id]') || info;
    var items = Array.prototype.slice.call(gallery.querySelectorAll('[data-image-id]')).map(function(slide) {
      var img = slide.querySelector('img');
      var mediaId = slide.getAttribute('data-media-id');
      var thumbLink = scope.querySelector('[data-thumb-link][data-media-id="' + mediaId + '"]');
      var thumb = thumbLink ? thumbLink.closest('[data-thumb-item]') : null;
      var item = {
        slide: slide,
        thumb: thumb,
        mediaId: mediaId,
        tags: img ? (img.getAttribute('alt') || '').split('|').map(function(t) { return t.trim(); }).filter(Boolean) : []
      };
      vmfWatchImages(slide);
      vmfWatchImages(thumb);
      item.slideMark = document.createComment('vmf');
      slide.parentNode.insertBefore(item.slideMark, slide);
      if (thumb) {
        item.thumbMark = document.createComment('vmf');
        thumb.parentNode.insertBefore(item.thumbMark, thumb);
      }
      return item;
    });
    info.__vmf = { gallery: gallery, items: items };
    return info.__vmf;
  }

  function vmfApply(info, variant) {
    if (!variant) return;
    var state = vmfSetup(info);
    if (!state) return;
    var known = vmfOptionValues(info);
    function colourTags(item) {
      return item.tags.filter(function(t) { return known.indexOf(t) > -1; });
    }
    var tagged = state.items.filter(function(i) { return colourTags(i).length; });
    if (!tagged.length) return;
    var selected = (variant.options || [variant.option1, variant.option2, variant.option3]).filter(Boolean);
    var firstVisible = null;
    var firstColour = null;

    state.items.forEach(function(item) {
      var itemColours = colourTags(item);
      var isColourPhoto = itemColours.length > 0;
      var show = !isColourPhoto || itemColours.some(function(t) { return selected.indexOf(t) > -1; });
      if (show) {
        if (!item.slide.isConnected) item.slideMark.parentNode.insertBefore(item.slide, item.slideMark.nextSibling);
        if (item.thumb && !item.thumb.isConnected) item.thumbMark.parentNode.insertBefore(item.thumb, item.thumbMark.nextSibling);
        vmfRefreshImages(item.slide);
        vmfRefreshImages(item.thumb);
        if (!firstVisible) firstVisible = item;
        if (isColourPhoto && !firstColour) firstColour = item;
      } else {
        item.slide.classList.remove('media--active', 'media--hiding');
        item.slide.classList.add('media--hidden');
        if (item.slide.isConnected) item.slide.remove();
        if (item.thumb && item.thumb.isConnected) item.thumb.remove();
      }
    });

    var hasActive = state.items.some(function(i) {
      return i.slide.isConnected && i.slide.classList.contains('media--active');
    });
    var target = firstColour || firstVisible;
    if (!hasActive && target) {
      state.gallery.dispatchEvent(new CustomEvent('theme:media:select', { bubbles: true, detail: { id: target.mediaId } }));
    }
    document.dispatchEvent(new CustomEvent('theme:resize', { bubbles: true }));
  }

  function vmfInfos() {
    return Array.prototype.slice.call(document.querySelectorAll('product-info[data-product-handle]')).filter(function(info) {
      return VMF_HANDLES.indexOf(info.getAttribute('data-product-handle')) > -1;
    });
  }

  function vmfSelectedVariant(info) {
    var el = info.querySelector('variant-selects [data-selected-variant]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function vmfInit() {
    vmfInfos().forEach(function(info) { vmfApply(info, vmfSelectedVariant(info)); });
    if (window.subscribe && window.theme && window.theme.PUB_SUB_EVENTS) {
      window.subscribe(window.theme.PUB_SUB_EVENTS.variantChange, function(event) {
        var data = event && event.data;
        if (!data || !data.variant) return;
        vmfInfos().forEach(function(info) {
          var section = info.getAttribute('data-original-section') || info.getAttribute('data-section');
          if (!data.sectionId || section === data.sectionId) vmfApply(info, data.variant);
        });
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', vmfInit);
  } else {
    vmfInit();
  }

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
